import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { FaPrint, FaArrowLeft } from 'react-icons/fa';

const ZpHeadWorkOrderView = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { regData, workData } = location.state || {};
    
    useEffect(() => {
        // Scroll to top on load
        window.scrollTo(0, 0);
    }, []);

    if (!regData || !workData) {
        return (
            <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50 p-4 font-marathi">
                <div className="bg-white p-8 rounded-xl shadow-md text-center max-w-md">
                    <h2 className="text-xl font-bold text-red-600 mb-4">माहिती उपलब्ध नाही</h2>
                    <p className="mb-6 text-gray-500 font-bold">कृपया वर्क ऑर्डर यादीतून पुन्हा प्रयत्न करा.</p>
                    <button 
                        onClick={() => navigate(-1)}
                        className="bg-[#4e73df] text-white px-8 py-2.5 rounded-lg hover:bg-blue-700 transition shadow-md font-bold"
                    >
                        परत जा
                    </button>
                </div>
            </div>
        );
    }

    const userName = regData.name || `${regData.firstName || ''} ${regData.middleName || ''} ${regData.surname || ''}`.trim() || regData.fullName || regData.societyName || "-";
    const userAddress = `मु.पो. ${regData.atPo || regData.address || ''}, ता. ${regData.taluka || ''}, जि. ${regData.district || 'सांगली'}`;
    const panNo = regData.panNo || regData.panCardNo || "-";
    const gstNo = regData.gstNo || "-";
    const mobileNo = regData.whatsappNo || regData.mobile || regData.phoneNumber || "-";
    
    const date = new Date().toLocaleDateString('mr-IN');
    const tenderAgreementNo = `B-1/ ${Math.floor(Math.random() * 1000)} / 2025-26`;
    const inWardNo = `जिपसा/बांध/निविदा/का.आ./${workData.id || workData.workNumber || '16145'}/2025-26`;

    const formatAmount = (value) => {
        const amount = parseFloat(value);
        return isNaN(amount) ? "0" : amount.toLocaleString('en-IN');
    };

    return (
        <div className="min-h-screen bg-gray-100 py-10 print:bg-white print:py-0 font-marathi">
            {/* Header Controls - Hidden on Print */}
            <div className="max-w-[1000px] mx-auto mb-6 flex justify-between items-center px-4 no-print">
                <button 
                    onClick={() => navigate(-1)}
                    className="flex items-center gap-2 px-4 py-2 bg-white text-gray-600 rounded-lg shadow-sm hover:bg-gray-50 transition font-bold border border-gray-200"
                >
                    <FaArrowLeft /> मागे जा
                </button>
                <div className="flex items-center gap-4">
                    <div className="text-right">
                        <h1 className="text-lg font-bold text-gray-800 leading-none">कार्यारंभ आदेश (Work Order)</h1>
                        <p className="text-xs text-gray-500 font-bold mt-1 uppercase tracking-wider">सांगली जिल्हा परिषद</p>
                    </div>
                    <button 
                        onClick={() => window.print()}
                        className="flex items-center gap-2 px-6 py-2.5 bg-[#4e73df] text-white rounded-lg hover:bg-blue-700 transition shadow-lg font-bold"
                    >
                        <FaPrint size={18} /> प्रिंट करा
                    </button>
                </div>
            </div>

            {/* Document Content */}
            <div className="max-w-[1000px] mx-auto bg-white p-12 shadow-2xl print:shadow-none print:p-4 font-serif text-[13px] leading-tight text-black border-gray-100 border relative">
                
                {/* Formal Header */}
                <div className="flex justify-between items-center mb-1">
                    <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS8X3zR9E_wX-9Lh-0A-0F_U5z0L-7-1-9-A&s" alt="ZP Logo" className="w-16 h-16 object-contain" />
                    <div className="text-center flex-1">
                        <h1 className="text-[20px] font-bold">जिल्हा परिषद, सांगली</h1>
                        <h2 className="text-[16px] font-bold">बांधकाम विभाग</h2>
                        <p className="text-[11px] font-medium">मध्यवर्ती प्रशासकीय इमारत, सांगली - मिरज रोड, पुष्पराज चौक, सांगली ता - मिरज जि - सांगली</p>
                    </div>
                    <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ7y2C_lY6f4S_Q0G_n_i9y_Y_4_O_2-9A&s" alt="Swachh Bharat Logo" className="w-20 h-10 object-contain" />
                </div>

                <div className="flex justify-between text-[11px] mb-1 font-bold">
                    <p>फोन नं :- ०२३३-२३७२७१९</p>
                    <p>Email ID :- eeworkszpsangli@gmail.com</p>
                </div>

                <hr className="border-black border mb-1" />
                <h2 className="text-center text-[16px] font-black mb-1 underline uppercase tracking-widest">कार्यारंभ आदेश</h2>
                <hr className="border-black border mb-2" />

                {/* Metadata Table */}
                <table className="w-full mb-2 border-collapse border border-black text-[12px]">
                    <tbody>
                        <tr>
                            <td className="border border-black p-1.5 w-[55%]">जा.क्रं/जिपसा/बांध/लेखा- <span className="font-bold underline">/2025 - 2026</span></td>
                            <td className="border border-black p-1.5">दिनाक:- <span className="font-bold underline">. . . .</span></td>
                            <td className="border border-black p-1.5 text-right font-medium">निविदा करारपत्र क्रं. B-1/ <span className="font-bold">{tenderAgreementNo.split('/')[1]}</span> /2025 - 2026</td>
                        </tr>
                    </tbody>
                </table>

                {/* Account Head Table */}
                <table className="w-full mb-2 border-collapse border border-black text-[12px]">
                    <tbody>
                        <tr>
                            <td className="border border-black p-1.5 w-1/3">लेखाशिर्ष</td>
                            <td colSpan="3" className="border border-black p-1.5 font-bold underline uppercase">{workData.schemeName || regData.scheme || 'जिल्हा वार्षिक योजना जिल्हा परिषद शाळा दुरुस्ती'}</td>
                        </tr>
                        <tr>
                            <td className="border border-black p-1.5">काम वाटप बैठक क्रं.</td>
                            <td className="border border-black p-1.5 font-bold w-1/4"></td>
                            <td className="border border-black p-1.5 w-1/6">काम क्रं.</td>
                            <td className="border border-black p-1.5 font-bold w-1/4">{workData.id || workData.workNumber || '16145'}</td>
                        </tr>
                    </tbody>
                </table>

                {/* Contractor Section */}
                <div className="mb-2">
                    <p className="font-bold mb-1 italic underline">प्रति,</p>
                    <div className="pl-4">
                        <p className="font-black text-[15px] text-gray-900 border-b border-gray-100 pb-1">मक्तेदाराचे नांव व पत्ता :- <span className="font-black underline mx-2">{userName}, {userAddress}</span></p>
                    </div>
                </div>

                {/* Credentials Table */}
                <table className="w-full mb-3 border-collapse border border-black text-center text-[12px]">
                    <tbody>
                        <tr className="bg-gray-50/30">
                            <td className="border border-black p-1.5 w-1/6 font-bold">पॅन कार्ड नं.</td>
                            <td className="border border-black p-1.5 w-1/4 font-black underline tracking-wider">{panNo}</td>
                            <td className="border border-black p-1.5 w-1/6 font-bold">GST No.</td>
                            <td className="border border-black p-1.5 font-black underline tracking-wider">{gstNo}</td>
                            <td className="border border-black p-1.5 w-1/6 font-bold">मो.क्र.</td>
                            <td className="border border-black p-1.5 font-black underline">{mobileNo}</td>
                        </tr>
                        <tr>
                            <td className="border border-black p-2.5 font-black bg-gray-50/50">कामाचे नांव :-</td>
                            <td colSpan="5" className="border border-black p-2.5 font-black text-left text-[14px] leading-relaxed uppercase">{workData.workName}</td>
                        </tr>
                    </tbody>
                </table>

                {/* Financials Table */}
                <table className="w-full mb-3 border-collapse border border-black text-[11px] text-left">
                    <tbody>
                        <tr>
                            <td className="border border-black p-1.5 w-1/4 font-bold">१. अनामत र.रु.</td>
                            <td className="border border-black p-1.5 w-[15%] font-black text-right underline">{formatAmount(parseFloat(workData.tenderAmount || 0) * 0.05)}</td>
                            <td className="border border-black p-1.5" colSpan="4"></td>
                        </tr>
                        <tr>
                            <td className="border border-black p-1.5 font-bold">२. चलनांने भरणा</td>
                            <td className="border border-black p-1.5 font-black text-right underline">{formatAmount(6144)}</td>
                            <td className="border border-black p-1.5 font-bold w-1/4">DCC बँक खाते क्रं. - <span className="font-bold underline">१०१५५३४७०००७७३३</span></td>
                            <td className="border border-black p-1.5 font-bold w-1/12 text-center">दिनांक</td>
                            <td className="border border-black p-1.5 font-bold underline" colSpan="2"> - </td>
                        </tr>
                        <tr className="bg-gray-50/20">
                            <td className="border border-black p-1.5 font-bold">एकूण जमा र.रु.</td>
                            <td className="border border-black p-1.5 font-black text-right underline">{formatAmount(6144)}</td>
                            <td className="border border-black p-1.5 font-bold">देयकातून वसूल करावयाची र.रु.</td>
                            <td className="border border-black p-1.5 font-black text-right underline w-1/6">{formatAmount(24576)}</td>
                            <td className="border border-black p-1.5 font-bold text-center w-1/12">एकूण</td>
                            <td className="border border-black p-1.5 font-black text-right underline w-1/6">{formatAmount(30720)}</td>
                        </tr>
                        <tr>
                            <td colSpan="6" className="border border-black p-1.5 font-black bg-gray-50/50 underline">या कार्यालयाकडील मक्ते मंजूरी टिपणी दिनांक</td>
                        </tr>
                    </tbody>
                </table>

                <p className="mb-2 text-[12px] font-medium leading-relaxed">अनामत रक्कम व निविदा विषयक सर्व कागदपत्रे आपण पूर्ण केलेली असल्याने आपली वरील कामाची निविदा खालील अंदाजपत्रकीय दराने मान्य करणेत येत आहे.</p>

                {/* Acceptance Grid */}
                <table className="w-full mb-3 border-collapse border border-black text-center text-[11px]">
                    <thead className="bg-gray-50/50">
                        <tr>
                            <th className="border border-black p-1.5 w-1/4">१) निविदा प्रसिद्ध र.रु.</th>
                            <th className="border border-black p-1.5 font-black">{formatAmount(workData.tenderAmount)}</th>
                            <th className="border border-black p-1.5 w-1/6">GST १८%</th>
                            <th className="border border-black p-1.5 font-black">{formatAmount(parseFloat(workData.tenderAmount || 0) * 0.18)}</th>
                            <th className="border border-black p-1.5 w-1/6">विमा</th>
                            <th className="border border-black p-1.5 font-black">{formatAmount(2595)}</th>
                            <th className="border border-black p-1.5 w-1/6 font-bold">एकूण र.रु.</th>
                            <th className="border border-black p-1.5 font-black underline">{formatAmount(parseFloat(workData.tenderAmount || 0) * 1.18 + 2595)}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td className="border border-black p-1.5 font-bold">२) कामाची मुदत व अंतिम दि.</td>
                            <td className="border border-black p-1.5 font-black">४ महिने</td>
                            <td className="border border-black p-1.5 font-bold">दि.</td>
                            <td className="border border-black p-1.5"></td>
                            <td className="border border-black p-1.5 font-bold" colSpan="2">५) दोष दायित्व कालावधी (DLP)</td>
                            <td className="border border-black p-1.5 font-black text-center" colSpan="2">२४ महिने</td>
                        </tr>
                    </tbody>
                </table>

                {/* Terms and Conditions - Formal Marathi Text */}
                <div className="space-y-1.5 text-[11px] leading-[1.3] text-gray-800 font-medium">
                    <p className="flex gap-2"><span>1)</span> <span>मा.आयुक्त पुणे, यांचेकडील दि.5/9/2018 रोजीचे परिपत्रकानुसार कामाची मुदत संपण्यापूर्वी 15 दिवस आधी मुदतवाढीसाठी रितसर अर्ज सादर करणे आवश्यक आहे. विहित कालावधीत मुदतवाढ अर्ज सादर न केल्यास ज्या दिवशी मुदतवाढ अर्ज देणे अपेक्षित होते त्या तारखेपासून ते प्रत्यक्ष अर्ज प्राप्त झाल्याच्या दिनांकापर्यंत प्रतिदिन दंड र.50/- आकारण्यात येईल. मुदतवाढी संदर्भात अंतिम निर्णय मा.अति.मु.का.अ. यांचा राहील.</span></p>
                    <p className="flex gap-2"><span>2)</span> <span>सदरचे काम हे पोट कंत्राटदारामार्फत (sb contractor) करता येणार नाही. आणि सदर काम आपण स्वतः केले असल्याचे आवश्यक कागदपत्रे मागणी केल्यास सादर करणे आपणांवर बंधनकारक राहील.</span></p>
                    <p className="flex gap-2"><span>3)</span> <span>करारनाम्यात नमूद केल्याप्रमाणे कंत्राटदाराने शासकीय विमा निधी महाराष्ट्र राज्य यांच्याकडे कंत्राटी कामाचा व त्यांच्याकडे काम करण्यास नियुक्त केलेल्या कामगारांचा विमा प्रत्यक्ष काम सुरु करणेपूर्वी उतरविणे अनिवार्य राहील. त्याबाबतचे प्रमाणपत्र कामाच्या पहिल्या देयकासोबत देणे आवश्यक आहे. जर काम सुरु असताना विमा उतरविला असेल तर विमा रक्कम परत केली जाणार नाही. तसेच विमा उतरविला नसेल तर शासनाच्या प्रचलित नियमानुसार पहिल्या देयकातून विम्याची सर्व रक्कम वसूल केली जाईल.</span></p>
                    <p className="flex gap-2 font-bold"><span>4)</span> <span className="underline">उपरोक्त काम आपण उप अभियंता (इवद) पं.स. <b>{regData.taluka || 'शिराळा'}</b> यांचे मार्गदर्शनाखाली त्वरीत सुरु करावे.</span></p>
                    <p className="flex gap-2"><span>5)</span> <span>कामाच्या ठिकाणी कामाचा सविस्तर माहिती फलक लावल्यानंतर प्रत्यक्ष लाईनआऊट देऊन काम चालू केले जाईल यांची नोंद घ्यावी.</span></p>
                    <p className="flex gap-2"><span>6)</span> <span>ठेकेदाराने कामगारांचे / मजुरांचे देयक आधार क्रमांकाशी जोडलेल्या बँक खात्यात जमा केल्याचे प्रमाणपत्र जमा करावयाचे आहे. हे प्रमाणपत्र करार केल्यापासून 60 दिवसात जमा करावयाचे आहे. जर करारनाम्याची मुदत 60 दिवसांपेक्षे कमी असल्यास 15 दिवसात जमा करावयाचे आहे.</span></p>
                    <p className="flex gap-2"><span>7)</span> <span>मक्तेदाराने 15 दिवसामध्ये काम सुरु करणे बंधनकारक राहील. पुढील 15 दिवसामध्ये कामाचा प्रगती अहवाल व छायाचित्र सादर करावे. उक्त कालावधीत जर काम सुरु झाले नाही तर आपण विलंबाबाबत योग्य खुलासा सादर करणे बंधनकारक राहील, खुलासा योग्य अथवा समाधानकारक नसल्यास आपला कार्यारंभ आदेश विना नोटीस रद्द केला जाईल यांची नोंद घ्यावी.</span></p>
                    <p className="flex gap-2 font-black italic"><span>8)</span> <span><b>अट</b> - ज्या कामाची प्रशासकीय मान्यता सन 2025-26 व तदनंतरची आहे. त्या मक्तेदारांनी प्रत्यक्ष काम सुरु करण्यापूर्वी स्वतः चे बँक खात्याची माहिती (बेनिफिशियरी) या कार्यालयाकडून भरून घेऊनच काम सुरु करावे.</span></p>
                </div>

                {/* Signatures */}
                <div className="mt-6 flex flex-col items-end">
                    <div className="text-center font-black text-[13px] mr-12 space-y-0.5">
                        <p className="h-8"></p>
                        <p>कार्यकारी अभियंता (इ.ब.द.)</p>
                        <p>जिल्हा परिषद, सांगली.</p>
                    </div>
                </div>

                <div className="mt-4 text-[11px] space-y-0.5 font-bold border-t border-gray-100 pt-3">
                    <p>प्रत :- उप अभियंता (इबद) पंचायत समिती <b>{regData.taluka || 'शिराळा'}</b> यांना माहितीसाठी.</p>
                    <p>2/- कामाचा प्रगती अहवाल दरमहा या कार्यालयास सादर करावा, संबंधित ठेकेदाराने सविस्तर माहिती फलक लावले नंतरच प्रत्यक्ष लाईनआऊट देऊन काम करणेचे आहे. अशा शासनाच्या सक्त सूचना आहेत त्यानुसार कार्यवाही करावी. कामावरील खर्च मंजूर अनुदाने इतका व मंजूर प्रशासकीय मान्यते पर्यंत मर्यादित ठेवणेत यावा. त्याचप्रमाणे ज्या कामाची प्रशासकीय मान्यता सन २०२५-२६ व तदनंतर आली आहे ते काम सुरु करताना काम चालू होण्या पूर्वीचे Geo-Tag फोटो zpfms या web site वरती अपलोड करून काम सुरु करणेची दक्षता घ्यावी. जर सदरचे फोटो अपलोड करणेचे राहिल्यास या कामाच्या देयकाची जबाबदारी आपली राहील याची नोंद घ्यावी.</p>
                    <p>प्रत :- उप संचालक विमा संचालालय, महाराष्ट्र राज्य म्हाडा <b>264</b>, पहिला मजला, वांद्रे (पूर्व) मुंबई <b>400 051</b> यांना माहितीसाठी</p>
                    <p>प्रत :- प्रकल्प शाखा.</p>
                </div>

                {/* Footer Copyright */}
                <div className="absolute bottom-4 left-0 right-0 text-center text-[10px] text-gray-400 font-bold no-print">
                    © Copyright 2026 Zilla Parishad Sangli. Design & Developed by Zilla Parishad.
                </div>

                {/* Watermark */}
                <div className="absolute inset-0 flex items-center justify-center opacity-[0.03] pointer-events-none select-none z-0">
                    <img 
                        src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS8X3zR9E_wX-9Lh-0A-0F_U5z0L-7-1-9-A&s" 
                        alt="ZP Logo" 
                        className="w-[450px]"
                    />
                </div>
            </div>

            <style>{`
                .font-marathi {
                    font-family: 'Hind', sans-serif;
                }
                @import url('https://fonts.googleapis.com/css2?family=Hind:wght@400;500;600;700&display=swap');
                @media print {
                    .no-print { display: none !important; }
                    body { background: white !important; margin: 0; padding: 0; }
                    .bg-white { box-shadow: none !important; border: none !important; }
                    .shadow-2xl { box-shadow: none !important; }
                    .p-12 { padding: 5mm !important; }
                    table { border: 1px solid black !important; border-collapse: collapse !important; width: 100% !important; }
                    th, td { border: 1px solid black !important; padding: 4px !important; }
                    hr { border-top: 1px solid black !important; }
                    @page {
                        size: A4;
                        margin: 10mm;
                    }
                }
            `}</style>
        </div>
    );
};

export default ZpHeadWorkOrderView;
